import React from 'react';

import { useTranslation } from 'react-i18next';

import { AppState } from '@ttstr/reducers';
import { useShallowEqualSelector } from '@ttstr/utils';
import { LoadingSpinner } from '..';
import Address from '../Address/Address';

const CartShippingAddress: React.FC = () => {
  const { t } = useTranslation();
  const { loading, cartReceived, ...addressFields } = useShallowEqualSelector(mapStateToProps);

  if (!cartReceived && loading) {
    return <LoadingSpinner label={t(`LOADING.CART`)} />;
  }

  return <Address className="shipping-address" {...addressFields} />;
};

function mapStateToProps(appState: AppState) {
  const { cart, loading, cartReceived } = appState.Cart;
  const {
    firstname,
    lastname,
    companyname,
    street,
    zip_code,
    city,
    state,
    country,
    address_addition,
    email,
    phone,
    shipping_firstname,
    shipping_lastname,
    shipping_companyname,
    shipping_street,
    shipping_zip_code,
    shipping_city,
    shipping_state,
    shipping_country,
    shipping_address_addition,
    use_shipping_address,
  } = cart;

  const shipping_address = use_shipping_address
    ? {
        firstname: shipping_firstname,
        lastname: shipping_lastname,
        companyname: shipping_companyname,
        street: shipping_street,
        zip_code: shipping_zip_code,
        city: shipping_city,
        state: shipping_state,
        country: `${shipping_country}`.toUpperCase(),
        address_addition: shipping_address_addition,
      }
    : {
        firstname,
        lastname,
        companyname,
        street,
        zip_code,
        city,
        state,
        country: `${country}`.toUpperCase(),
        address_addition,
      };

  return {
    cartReceived,
    loading,
    ...shipping_address,
    email,
    phone,
  };
}

export default React.memo(CartShippingAddress);
